export default __webpack_public_path__ + "static/media/Flag_of_Maldives.0c971d79.svg";